import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { Chip } from '@/components/kit';
import { useNarrowViewport, useShellChrome } from '@/layouts/shellChrome';
import { usePageMeta } from '@/hooks/usePageMeta';
import { useWorklist } from './api';
import { shortName, valuesLine } from './format';
import { buildItems, isClosed } from './model';
import { useOpenTest } from './components/WorklistPane';
import { PhoneScreen } from './components/PhoneScreen';

/**
 * A bundle, inside — one sitting (phone `g_t3`). The desk shows the same
 * sequence as the worklist's docked pane, so there it docks instead.
 */
export function TechBundlePage() {
  const { id } = useParams();
  const narrow = useNarrowViewport();
  const navigate = useNavigate();
  const list = useWorklist();
  const open = useOpenTest();
  usePageMeta({ title: 'Bundle' });
  const item = buildItems(list.data?.tasks ?? []).find((i) => i.tasks.some((t) => t.id === id)) ?? null;
  const sig = item ? item.tasks.map((t) => `${t.id}:${t.state}:${t.lane}`).join(',') : 'none';

  useShellChrome(
    {
      raw: true,
      phone: (
        <PhoneScreen door="worklist" crumb="Worklist" title={item ? `${shortName(item.next.patient)} · bundle` : 'Bundle'}
          onBack={() => navigate('/technician/worklist')}>
          {item ? (
            <>
              {item.tasks.map((t, i) => {
                const isNext = t.id === item.next.id && !isClosed(t);
                return (
                  <div key={t.id} className={`card${isNext ? ' card-acc' : ''}`}>
                    <div className="flex" style={{ gap: 8 }}>
                      <p className="t-strong grow">{i + 1} · {t.title}</p>
                      {t.state === 'done' ? <Chip kind="success" small>done ✓</Chip>
                        : t.state === 'cant' ? <Chip kind="warn" small>came back</Chip>
                          : t.state === 'in_progress' ? <Chip kind="soft" small className="chip-act w6" onClick={() => open(t)}>Open</Chip>
                            : isNext ? <Chip kind="soft" small className="chip-act w6" onClick={() => open(t)}>Start</Chip>
                              : t.sequence === 'after_drops' ? <Chip kind="outline" small>after drops</Chip> : null}
                    </div>
                    {t.state === 'done' && t.values ? <p className="t-sec mut mt4">{valuesLine(t.values)}</p>
                      : isNext && t.sequence === 'before_dilation' ? <p className="t-sec mut mt4">before dilation — order matters</p> : null}
                  </div>
                );
              })}
              <div className="card mt16" style={{ borderColor: 'var(--success-600)' }}>
                <p className="t-sec w6 grn">
                  {item.tasks.filter((t) => t.state === 'done').length} of {item.tasks.length} done → each sends as it finishes; the bundle closes itself
                </p>
              </div>
            </>
          ) : list.data ? (
            <div className="card card-ghost center"><p className="t-sec mut">This bundle is no longer on your worklist.</p></div>
          ) : null}
        </PhoneScreen>
      ),
    },
    [sig],
  );

  if (!narrow && list.data) return <Navigate to="/technician/worklist" replace state={item ? { select: item.id } : null} />;
  return <div className="maie desk tech-root" />;
}
